export default {

  button: {
    login: 'Login',
    logout: 'Logout',
    changePassword: 'Change Password',
    edit: 'Edit',
    copy: 'Copy',
    update: 'Update',
    detail: 'Details',
    reset: 'Reset',
    search: 'Search',
    export: 'Export',
    import: 'Import',
    exportExcel: 'Export Excel',
    control: 'Control Folder',
    distributor: {
        createProduct: 'Create Product'
    },
    lock: 'Lock',
    unlock: 'Unlock',
    delete: 'Delete',
    reinitPwd: 'Reset Password',
    resetOtp: 'Reset OTP',
    cancel: 'Cancel',
    chooseFile: 'Choose a File',
    save: 'Save',
    consult: 'Consult',
    forceActivate: 'Force Activate',
    inactivate: 'Inactivate',
    add: 'Add',
    create: 'Create',
    activate: 'Activate',
    deactivate: 'Disable',
    block: 'Block',
    unblock: 'Unblock',
    ok: 'OK',
    close: 'Close',
    displayErrors: 'Display Errors',
    confirm: 'Confirm'
  },

  img: {
    logo: 'Up Logo'
  },

  login: {
    form: {
      login: 'Username',
      password: 'Password'
    },
    footer: '© Worldline -'
  },

  label: {
    logout: {
      warning: "You will be logged out in 1 minute due to inactivity of 15 minutes.\n Please move the mouse or press a key to stay logged in.",
      disconnected: "You have been logged out due to inactivity."
    },
    actions: 'Actions',
    results: {
      show: 'Show',
      number: 'items out of 1 found | items out of {count} found'
    },
    affiliate: {
      selectedDistributorRef: 'Distributor',
      selectedCommercialProduct: 'Commercial Product',
      selectedAffiliateStatus: 'Affiliate Contract Status',
      selectedContractId: 'Affiliate Contract ID',
      selectedProviderId: 'Technical Provider ID',
      selectedMerchantId: 'Merchant ID',
      selectedCreationDateStart: 'Creation Date, from',
      selectedCreationDateEnd: 'To',
      selectedClosingDateStart: 'Closing Date, from',
      selectedClosingDateEnd: 'To',
      detail: {
        detail: 'Details',
        contractId: 'Affiliate Contract ID',
        distributorId: 'Distributor',
        productId: 'Product ID',
        maxAmountLoad: 'Maximum Load Amount',
        minAmountLoad: 'Minimum Load Amount',
        maxAmountUnload: 'Maximum Unload Amount',
        minAmountUnload: 'Minimum Unload Amount',
        balance: 'Balance',
        mcc: 'MCC',
        countryCode: 'Country Code',
        address: 'Address',
        phone1: 'Phone 1',
        phone2: 'Phone 2',
        email: 'Email',
        creationDate: 'Creation Date',
        status: 'Status',
        statusDate: 'Status Update Date',
        activationDate: 'Activation Date',
        inactivationDate: 'Inactivation Date',
        closingDate: 'Closing Date',
        closingEffectiveDate: 'Effective Closing Date',
        providerList: 'Technical Providers List',
        providerId: 'Technical Provider ID',
        connectionMode: 'Connection Mode',
        merchantList: 'Merchants List',
        merchantId: 'Merchant ID',
        structureId: 'Structure ID',
        channelList: 'Acceptance Channels',
        messageList: 'Allowed Messages',
        IdInfosGroupeFiltrage1: 'Filtering Group 1',
        IdInfosGroupeFiltrage2: 'Filtering Group 2',
        IdInfosGroupeFiltrage3: 'Filtering Group 3',
        IdInfosGroupeFiltrage4: 'Filtering Group 4',
        IdInfosGroupeFiltrage5: 'Filtering Group 5',
        addProviderLowerCase: 'Add Provider',
        addMerchantLowerCase: 'Add Merchant',
        addProvider: {
            providerId: 'Technical Provider ID',
            providerIdInfo: 'Mandatory field. Maximum 45 characters.',
            connectionMode: 'Connection Mode',
            connectionModeInfo: 'Mandatory field.',
            addProvider: 'ADD PROVIDER',
            editProvider: 'EDIT PROVIDER',
            deleteProvider: 'DELETE PROVIDER',
            confirmationDeleteProvider: 'Do you want to delete the provider'
        },
        addMerchant: {
          addMerchant: 'ADD MERCHANT',
          editMerchant: 'EDIT MERCHANT',
          deleteMerchant: 'DELETE MERCHANT',
          confirmationDeleteMerchant : 'Do you want to delete the merchant',
          provider: 'Provider',
          legend: 'New merchant associated with the provider',
          merchantId: 'Merchant ID',
          merchantIdInfo: 'Mandatory field. Maximum 45 characters.',
          structureId: 'Structure ID',
          structureIdInfo: 'Maximum 45 characters.',
          acceptanceChannels: 'Acceptance Channels',
          acceptanceChannelsInfo: 'Mandatory field. Proximity Payment and/or Distance Selling',
          acceptanceChannelsPDP: 'Proximity Payment',
          acceptanceChannelsVAD: 'Distance Selling',
          allowedMessages: 'Allowed Messages',
          allowedMessagesInfo: 'If no message is selected, all messages will be associated with the merchant',
          filteringGroup1: 'Filtering Group 1',
          filteringGroup1Info: '3-character filter. Maximum 101 filters.',
          filteringGroup2: 'Filtering Group 2',
          filteringGroup3: 'Filtering Group 3',
          filteringGroup4: 'Filtering Group 4',
          filteringGroup5: 'Filtering Group 5',
        }
      }
    },
    card: {
      distributor: 'Distributor',
      commercialProduct: 'Commercial Product',
      funderContract: 'Funder Contract',
      beneficiaryService: 'Beneficiary Service',
      cardId: 'Card ID',
      cardNum: 'Card Number',
      expirationDate: 'Expiration Date',
      sequenceNumber: 'Sequence Number',
      cardStatus: 'Card Status',
      activationDate: 'Activation Date',
      creationDate: 'Creation Date',
      cardInfo: 'PAN / Expiry Date / PSN',
      orderStatus: 'Order Status',
      expeditionRef: 'Expedition Ref',
      productionRef: 'Production Ref',
      status: 'Status',
      detail: {
        cardDetails: 'CARD DETAILS',
        cardEvent: {
          ExtActivationEvent: 'Activation',
          ExtBlockingCardEvent: 'Blocking',
          ExtDeactivationCardEvent: 'Deactivation',
          ExtFirstIssueCardEvent: 'First Issue',
          ExtRenewalCardEvent: 'Renewal',
          ExtReplacementCardEvent: 'Replacement',
          ExtUnblockingCardEvent: 'Unblocking'
        },
        // Details
        details: 'Details',
        distributor: 'Distributor',
        product: 'Product',
        beneficiary: 'Beneficiary',
        funder: 'Funder',
        cardId: 'Card ID',
        pan: 'PAN',
        cardExpiryDate: 'Expiration Date',
        psn: 'Sequence Number',
        cardStatus: 'Card Status',
        logoRef: 'Logo Reference',
        activationDate: 'Activation Date',
        activationLimitDate: 'Activation Limit Date',
        artworkRef: 'Card Visual Reference',
        funderName: 'Funder Name',
        cardStatusReason: 'Status Reason Code in Addition to Status',
        orderRef: 'Order Fabrication Reference',
        expeditionOrderRef: 'Expedition Order Reference',
        orderStatus: 'Order Status',
        issuingDate: 'Issuing Date',
        blockingDate: 'Card Blocking Date',
        lostStolenDate: 'Card Lost/Stolen Date',
        embossingName: 'Embossed Name on Card',
        packagingRef: 'Packaging Reference',
        pinTryCounter: 'Maximum Number of Incorrect PIN Entries',
        contactLessCardInterfaceStatus: 'Contactless Card Interface Status',
        cardProfileRef: 'Card Carrier Equipment Profile Reference',
        emvProfileId: 'EMV Profile Reference',
        emvCmdList: 'List of EMV Commands Created for the Card',
        emvCmdDate: '',
        emvCmdstatus: '',
        emvCmdtype: '',
        emvCmdretryCounter: '',
        cardEventList: 'Card Events',
        cardEventType: 'Event Type',
        cardEventDate: 'Event Date',
        cardEventCardId: 'Card ID',
        pKeySensitiveLabel: 'Digital Key',
        pKeySensitiveDataId: 'Key ID',
        pKeyCreationDate: 'Key Creation Date',
        startDate: 'Start date',
        endDate: 'End date',
        // Account
        account: 'Account',
        balance: 'Balance',
        available: 'Available',
        beneficiaryAccount: 'Beneficiary Account',
        // Cards
        cards: {
          cards: 'Cards',
          cardId: 'Card ID #',
          cardStatus: 'Status',
          panCard: 'PAN',
          psnCard: 'PSN',
          expiryDate: 'Expiration Date'
        },
        // Orders
        orders: {
          commands: 'Orders',
          expeditionRef: 'Expedition Ref',
          orderStatus: 'Order Status',
          documentRef: 'Document Reference',
          personalizedCardData: 'Personalized card data',
          personalizedInsetData: 'Personalized Inset Data',
          otherDataList: 'Other Data'
        },
        modal : {
          cardActivation: 'CARD ACTIVATION',
          loadOption: 'You can optionally load the account during during the card activation using the form below.',
          eur: 'EUR',
          cardDeactivation: 'CARD DEACTIVATION',
          reason: 'Reason',
          cardBlocking: 'CARD BLOCKING'
        },
        tokenData: 'Tokens',
        tokenId: 'IdToken',
        tokenUniqueReference: 'Token Unique Reference MP',
        consumerFacingEntityName: 'Consumer Facing Entity Name',
        tokenStatus: 'Status',
        tokenExpiryDate: 'Expiration date'
      }
    },
    account: {
      selectedDistributorRef: 'Distributor',
      selectedCommercialProduct: 'Commercial Product',
      selectedFunderContract: 'Funder Contract',
      selectedBeneficiaryService: 'Beneficiary Service',
      selectedAccountStatus: 'Account Status',
      selectedCreationDate: 'Creation Date',
      selectedClosingDate: 'Closing Date',
      distributorRef: 'Distributor Reference',
      productRef: 'Product Reference',
      status: 'Status',
      category: 'Category',
      accountNumber: 'Account Number',
      balance: 'Balance',
      openToBuy: 'Available',
      singleFunderAccount: 'Single Funder Account',
      dataFromCFU: 'Data from Single Funder Account',
      dataFromSB: 'Data from Beneficiary Service',
      beneficiaryStatus: 'Beneficiary Status',
      details: 'Details',
      beneficiary: 'Beneficiary',
      funder: 'Funder',
      product: 'Product',
      beneficiaryServiceProfile: 'Beneficiary Service Profile',
      account: 'Account',
      funderAccount: 'Funder Account',
      beneficiaryAccount: 'Beneficiary Account',
      cards: 'Cards',
      orders: 'Orders',
      operations: 'Operations',
      notificationData: 'Notification Data',
      noElement: 'No Element to Display',
      detail: {
        beneficiaryAccountDetails: 'BENEFICIARY ACCOUNT DETAILS',
        funderAccountDetails: 'FUNDER ACCOUNT DETAILS',
        accountStatus: 'Account Status',
        rightReference: 'Right Reference',
        startDate: 'Start Date',
        expirationDate: 'Expiration Date',
        statusReasonCode: 'Status / Reason Code',
        loadedAmountRemaining: 'Loaded Amount / Remaining',
        actions: 'Actions'
      },
      operation: {
        voucherOperations: 'Voucher operations',
        operationId: 'Operation ID',
        operationType: 'Operation Type',
        extReference: 'External Reference',
        operationDate: 'Operation Date',
        consult: 'Consult'
      },
      restriction: {
        restrictions: 'Restrictions',
        maxAmountLoad: 'Maximum Load Amount',
        minAmountLoad: 'Minimum Load Amount',
        maxAmountUnload: 'Maximum Unload Amount',
        minAmountUnload: 'Minimum Unload Amount',
        minPurchaseLimit: 'Minimum Purchase Limit',
        maxPurchaseLimit: 'Maximum Purchase Limit',
        fixedProhibitedPeriods: 'Fixed Prohibited Periods',
        authorizedUtilizationDays: 'Authorized Utilization Days',
        MCCRestrictions: 'MCC Restrictions',
        authorizedUtilizationHours: 'Authorized Utilization Hours',
        paymentsRestrictionsFixedPeriod: 'Restrictions on Payments - Fixed Period',
        periodType: 'Period Type',
        maxAmountUnloadPeriod: 'Maximum Unload Amount per Period',
        maxNumberPeriod: 'Maximum Number per Period',
        transactionType: 'Transaction Type',
        paymentsRestrictionsSlidingPeriod: 'Restrictions on Payments - Sliding Period',
      }
    },
    operation: {
      operationDetail: 'OPERATION DETAILS',
      details: 'Details',
      status: 'Status',
      acquisitionCountryCode: 'Acquisition Country Code',
      acquisitionDate: 'Acquisition Date',
      acquisitionMaterial: 'Acquisition Material',
      cardSchemeCode: 'Card Scheme Code',
      entryMode: 'Entry Mode',
      externalReference: 'External Reference',
      genericMCC: 'MCC Code',
      merchantNameAndLoc: 'Merchant Name and Location',
      operationCode: 'Operation Code',
      operationDate: 'Operation Local Date',
      originalAmount: 'Original Amount',
      reversal: 'Reversal Flag',
      reversalReason: 'Reversal Reason',
      validationMode: 'Validation Mode',
      valueDate: 'Value Date',
      cardExternalReference: 'Card External Reference',
      account: 'Account',
      cards: 'Cards',
      orders: 'Orders'
    },
    authorization: {
      distributor: 'Distributor Reference',
      holderNumber: 'Cardholder Number',
      cardId: 'Card ID',
      authorizationNumber: 'Authorization Number',
      authorizationDate: 'Authorization Date',
      startDate: 'Start Date',
      startTime: 'Start Time',
      endDate: 'End Date',
      endTime: 'End Time',
      id: '#',
      merchantId: 'Merchant Contract Number',
      transactionType: 'Transaction Type',
      amount: 'Amount',
      amountFormat: 'Specify in the smallest possible unit of the currency',
      currency: 'Currency',
      responseCode: 'Response Code',
      responseCodeDetailed: 'Detailed Response Code',
      acceptanceChannel: 'Acceptance Channel',
      date: 'Date',
      dateType: 'Transaction Date',
      codeRp: {
        _00: '- Authorization granted for the requested amount \n- Inquiry request not refused',
        _10: 'Authorization granted partially, within the available balance',
        _03: 'Invalid acceptor',
        _04: 'Suspicion of abusive use',
        _05: '- Do not honor \n- Transaction not allowed to the cardholder \n- Invalid transaction',
        _12: 'Invalid transaction (not processed by the server)',
        _13: 'Invalid amount',
        _14: 'Invalid card number',
        _25: 'Unable to locate record in the file',
        _29: 'File update impossible',
        _30: 'Syntax error',
        _34: 'Counterfeit card',
        _40: 'Contactless withdrawal not authorized',
        _41: 'Lost card',
        _43: 'Stolen card',
        _46: 'Invalid transaction (response code generate by SAER for invalid transaction date)',
        _47: 'Maximum number of incorrect PIN codes reached',
        _51: 'Insufficient funds',
        _54: 'Card expired',
        _55: 'Incorrect PIN',
        _56: 'Card not in file',
        _57: 'Transaction not allowed to the cardholder',
        _58: 'Transaction not allowed for this terminal',
        _59: 'Fraud suspicion',
        _61: 'Withdrawal amount exceeds limit',
        _63: 'Security rules not followed',
        _65: 'Frequency limit exceeded for contactless transactions',
        _75: 'Number of incorrect PIN entry attempts exceeded',
        _94: 'Duplicate request',
        _91: 'Timeout',
        _96: 'Financeur FO System Error',
        _98: 'Financeur FO Server Unavailable',
        _99: 'Initiator domain incident',
        _A0: 'Fallback in contact mode',
        _A1: 'Soft decline (electronic commerce only), 3DS with challenge required',
        _A2: 'PIN request in single TAP mode',
        _A3: 'New TAP with required authentication',
        _B0: 'Mandatory service can not be performed'
      },
      detail: {
        // ---- General Data ----
        generalData: 'General Data',
        referenceDistributeur: 'Distributor Reference',
        typeTransaction: 'Transaction Type',
        dateTransaction: 'Transaction Date',
        dateTransmissionTransaction: 'Transmission Date',
        dateMoveUp: 'MoveUp Date',
        numAut: 'Authorization Number',
        codeRetour: 'Return Code',
        codeRaisonDetaillee: 'Detailed Return Code',
        canalAcceptationValue: 'Acceptance Channel',
        idAcceptation: 'Acceptance ID',
        countryCode: 'Country Code',
        idTerminal: 'Terminal ID',
        traceNumber: 'Trace Number',
        posEntryMode: 'Pos Entry Mode',
        scheme: 'Scheme',
        mask: 'Mask',
        typeFacture: 'Invoice Type',
        acceptationContext: 'Acceptance Context',
        retrievalReferenceNumber: 'RRN',
        matchingAlgorithm: 'Matching Algorithm',
        level: 'Level ',
        authorizationReferenceList: 'Authorization Reference List',
        regularizationFlag: 'Top Regularization',
        authorizationReference: 'Authorization Reference',
        referenceProduit: 'Product Reference',
        preAuthorizationFlag: 'Top Pre-Authorization',
        posData: 'Pos Data',
        traceId: 'Trace ID',
        transactionLinkId : 'TLID',
        transactionReference : 'Transaction Reference',
        merchantSingleTapIndicator: 'Single tap indicator',
        codeMotifAutorisationSingleTap: 'Single Tap Authorization Reason Code',
        blockPINAlgorithm: 'PIN Bloc algorithm',
        blockPINFormat: 'PIN Bloc format',
        transactionAnalysisOverview: 'Decision on the transaction',
        transactionAnalysisTestResults: 'List of failed controls',
        regularizationOrigine: 'Regularization Origin',
        directSettlementMode: 'Ind Direct Settlement',
        saerDeclined: 'Saer Rejection',
        // ---- Merchant Data ----
        marchandData: 'Merchant Data',
        cardholderMerchantInitiatorTrInd: 'Transaction Initiator Indicator',
        finalAuthorizationIndicator: 'Final Authorization Indicator',
        idContratAffilie: 'Affiliate Contract ID',
        idMarchand: 'Merchant ID',
        nomMarchand: 'Merchant Name',
        villeMarchand: 'Merchant City',
        codepostalMarchand: 'Merchant Postal Code',
        paysMarchand: 'Merchant Country',
        referenceListe: 'Filtering List Identifier',
        idStructure: 'Structure ID',
        codeMCC: 'MCC Code',
        domesticAcceptorTaxId: 'Merchant Tax Identifier / SIRET Number',
        accountCategory: 'Account Category',
        accountNumber: 'Account Number',
        paymentFacilitatorId: 'Payment Facilitator ID',
        independentSalesOrgId: 'Independent Sales Organization ID',
        subMerchantId: 'Final Merchant ID',
        merchantCountryOrigin: 'Merchant Country of Origin',
        // ---- Cardholder Data ----
        porteurData: 'Cardholder Data',
        numCarte: 'Cardholder Number',
        psnCarte: 'Cardholder PSN',
        cardId: 'Card ID',
        cardExpiryDate: 'Card Expiration Date',
        referenceContratFinanceur: 'Funder Contract Reference',
        referenceServiceBeneficiaire: 'Beneficiary Service Reference',
        // ---- Monetary Data ----
        monetaireData: 'Monetary Data',
        amount: 'Amount',
        feeAmountAndSign: 'Fee Amount on transaction and sign',
        sameCurrency: 'Same currency as the transaction',
        currencyCode: 'Currency Code',
        solde: 'Balance',
        actualAmount: 'Authorized Amount',
        cardholderAmount: 'Cardholder Currency Amount',
        cardholderConversionRate: 'Cardholder Conversion Rate',
        cardholderCurrency: 'Cardholder Currency Code',
        complementAmount: 'Complement Amount',
        replacementAmount: 'Replacement Amount',
        cardholderReplacementAmount: 'Cardholder Replacement Amount',
        accountDetailList: 'Account Detail List',
        cashWithDrawalAccountAvailable: 'Cash Withdrawal Available',
        purchaseAccountAvailable: 'Purchase Available',
        purchaseAccountAvailableException: 'Purchase Available Exception',
        // ---- Authorization Response Specific Data ----
        authRespSpeciData: 'Authorization Response Specific Data',
        respAcceptorMessage: 'Emitter message for acceptance',
        respIssuerMessage: 'Emitter message for cardholder',
        respPartialApprovalFlag: 'Top partial auth',
        respCardStatus: 'Card Status',
        respCardExpiryDate: 'Card Expiry Date',
        // ---- Cancellations, Rectifications, and Rectification-Generating Notices Specific Data ----
        annulRedresSpeciData: 'Cancellations, Rectifications, and Rectification-Generating Notices Specific Data',
        oriAcquirerId: 'Original Acquirer ID',
        oriMontant: 'Original Amount',
        oriDateTransaction: 'Original Transaction Date',
        oriTraceNumber: 'Original Trace Number',
        onlinePartialReversalParam: 'Partial Reversal Authorized',
        onlinePartialReversalParam0: 'Not Authorized',
        onlinePartialReversalParam1: 'Authorized for 0120',
        onlinePartialReversalParam2: 'Authorized for 0400-DE95',
        onlinePartialReversalParam3: 'Authorized for 0120 and 0400-DE95',
        oriAuthorizationReference: 'Original Authorization Reference',
        // ---- Voucher Data ----
        vaucherData: 'Voucher Data',
        externalReference: 'External Voucher Reference',
        amountImpact: 'Voucher Amount',
        // ---- Security Data ----
        securitairesData: 'Security Data',
        transacIdAcceptor: 'Transaction Acceptor ID',
        cryptogram: 'Cryptogram',
        securityType: 'Security Type',
        cryptogramProcessInfo: 'Cryptogram Processing Info',
        cardholderAuthMethod: 'Cardholder Authentication Method',
        cryptogramCalcMethod: 'Cryptogram Calculation Method',
        onBehalfServices: 'Used Transaction Services',
        securityServicesData: 'Embedded Security Services',
        additionalData: 'Additional Data',
        indicator: 'Elect Commerce Indicator',
        walletName: 'Wallet Name',
        walletAdditionalData: 'Wallet Additional Data',
        walletIdentifier: 'Wallet ID',
        tokenId: 'Token ID',
        tokenAccountNumber: 'Token Account Number',
        tokenExpiryDate: 'Token Expiry Date',
        tokenRequestorId: 'Token Requestor ID',
        tokenType: 'Token Type',
        tokenStorageType: 'Token Storage Mode',
        tokenAssuranceLevel: 'Token Assurance Level',
        deviceType: 'Device Type',
        tokenWalletId: 'Wallet ID',
        lastEmvCommandResult: 'Last EMV Command Result',
        protocolVersion: 'Protocol Version',
        directoryServerTransactionId: 'Directory Server Transaction ID',
        // ---- Authorization Advice Specific Data ----
        avisAuthSpeciData: 'Authorization Advice Specific Data',
        codeRetourRequest: 'Return Code Authorization Advice',
        codeRetourDetailleRequest: 'Detailed Return Code',
        avisCodeMotif: 'Advice Reason Code',
        // ---- SCP Specific Data ----
        scpSpeciData: 'SCP Specific Data',
        scpRequestDate: 'SCP Request Date',
        scpResponseDate: 'SCP Response Date',
        substitutionPaymentReason: 'SCP Motif',
        scpResponseCode: 'SCP Response Code',
        scpNeedReversal: 'Reversal requested by SCP',
        saeCallData: 'External SAE Call Data',
        accountAvailable: 'Available Balance',
        amountAdjusted: 'Adjusted Amount',
        extSaeRequestDate: 'Call Date',
        extSaeResponseCode: 'Return Code',
        extSaeResponseDate: 'Response Date',
        opType: 'Operation Type',
        rejectNotificationReason: 'Reject Notification Reason',
        partialAuthorizationSupported: 'Partial Authorization Supported',
        partialAuthYes: 'Yes',
        partialAuthNo: 'No',
        extSaeSpeciData: 'External SAE Specific Data',
        accountUpdatableExtSae: 'Account Eligibility for Update by External SAE',
        accountUpdatableYes: 'Yes',
        accountUpdatableNo: 'No',
        ert: 'ERT (Technical and Regulatory Environment)',
        functionCode: 'Function Code',
        acquirerCountryCode: 'Acquirer Country Code'
      }
    },
    order: {
      orders: 'ORDERS',
      orderType: 'Order Type *',
      orderStatus: 'Order Status',
      expeditionRef: 'Expedition Reference',
      orderRef: 'Fabrication Order Reference',
      close: 'Close',
      orderDetails: 'ORDER DETAILS',
      details: {
        pinRepublication: 'PIN Republication',
        distributor: 'Distributor',
        funderContract: 'Funder Contract',
        beneficiary: 'Beneficiary',
        product: 'Product',
        orderType: 'Order Type',
        expeditionRef: 'Expedition Reference',
        orderStatus: 'Order Status',
        cardIdentifier: 'Card Identifier',
        PAN: 'PAN',
        expirationDate: 'Expiration Date',
        sequenceNumber: 'Sequence Number',
        cardVisualReference: 'Card Visual Reference',
        manufacturer: 'Manufacturer',
        sortCriteria: 'Sort Criteria',
        trackingDataList: 'Tracking Data List',
        documentReference: 'Document Reference',
        expeditionDate: 'Expedition Date',
        orderReference: 'Order Reference',
        mobilePhoneNumber: 'Mobile Phone Number',
        customizationType: 'Customization Type',
        deliveryAddress: 'Delivery Address',
        line1: 'Line 1',
        line2: 'Line 2',
        line3: 'Line 3',
        line4: 'Line 4',
        line5: 'Line 5',
        countryCode: 'Country Code',
        landlinePhoneNumber: 'Landline Phone Number',
        city: 'City',
        postalCode: 'Postal Code',
        deliveryType: 'Delivery Type',
        addresseeEmailPinCode: 'Addressee Email PIN Code Sending',
        embossedNameOnCard: 'Embossed Name on Card',
        extractionReference: 'Extraction Reference',
        orderHistory: 'Order History',
        statusChangeDate: 'Status Change Date',
        logoReference: 'Logo Reference',
        defaultDeliveryAddress: 'Default Delivery Address',
        fileNumber: 'File Number',
        orderReason: 'Order Reason',
        packageNumber: 'Package Number',
        packagingRef: 'Packaging Reference',
        customCardMessage: 'Custom Card Message',
        customizationElementsCardSlot: 'Customization Elements of the Card Slot',
        customedMessage: 'Custom Message',
        manufacturingStatusHistory: 'Manufacturing Status History',
        manufacturingStatus: 'Manufacturing Status',
        manufacturingDate: 'Manufacturing Date',
        manufacturingOrderRef: 'Manufacturing Order Ref',
        rejectDate: 'Reject Date',
        packageSenderRef: 'Packae Sender Reference',
        sendingType: 'Sending Type',
        cardOrderSequenceNumber: 'Card Order Sequence Number',
        noAddress: 'No Address',
        address: 'Address',
        email: 'Email',
        beneficiaryAccount: 'Beneficiary Account',
        cardPinRepublication: 'CARD PIN REPUBLICATION',
        sendingMode: 'Sending Mode',
        date: 'Date',
        pinCodePublisher: 'PIN Code Publisher',
        pinSendingType: 'PIN Sending Type',
        cancel: 'Cancel'
      }
    },
    clearing: {
      selectedDistributorRef: 'Distributor Reference',
      selectedScheme: 'Card Network',
      selectedPan: 'Card Number',
      selectedCardId: 'Card Identifier',
      selectedIdOperation: 'Transaction Identifier',
      selectedNumAut: 'Authorization Number',
      selectedClasseTransaction: 'Transaction Category',
      selectedTransactionStatus: 'Technical Status',
      selectedDateTransactionBegin: 'Transaction Start Date',
      selectedTimeTransactionBegin: 'Transaction Start Time',
      selectedDateTransactionEnd: 'Transaction End Date',
      selectedTimeTransactionEnd: 'Transaction End Time',
      selectedDateTraitementBegin: 'Processing Start Date',
      selectedTimeTraitementBegin: 'Processing Start Time',
      selectedDateTraitementEnd: 'Processing End Date',
      selectedTimeTraitementEnd: 'Processing End Time',
      selectedTransactionAmount: 'Amount',
      selectedCurrencyCode: 'Original Currency',
      distributorRef: 'Distributor Reference',
      cardSchemeCode: 'Card Network',
      pan: 'Card Number',
      cardId: 'Card Identifier',
      transactionCategory: 'Transaction Category',
      IdOperation: 'Transaction Identifier',
      dateTransaction: 'Transaction Date',
      processingDate: 'Processing Date',
      transactionAmount: 'Amount',
      currencyCode: 'Original Amount Currency',
      reversalFlag: 'Reversal Flag',
      offlineAutReversalFlag: 'Offline Authorization Reversal Flag',
      numAut: 'Authorization Number',
      detail: {
        transaction: {
          // ---- General Data ----
          generalData: 'General Data of a Transaction',
          idOperation: 'Transaction Identifier',
          classeTransaction: 'Transaction Category',
          technicalStatus: 'Technical Status',
          technicalErrorType: 'Technical Error Type',
          technicalErrorDetail: 'Technical Error Detail',
          clearingStatus: 'Clearing Status',
          transmissionDateAndTime: 'Transmission Date and Time',
          processingDate: 'Processing Date',
          transactionStatus: 'MCI Dispute Transaction Status',
          rejectReasonCode: 'MCI Rejection Reason',
          partialFlag: 'Partial Indicator',
          partialNumber: 'Partial Number',
          claimCbkId: 'Claim Identifier',
          cbkId: 'Dispute Identifier',
          cardIssuerReferenceData: 'Issuer Reference',
          reasonCode: 'Reason Code',
          messageText: 'Additional Message',
          reversalFlag: 'Cancellation Indicator',
          direction: 'Direction',
          collectionDisbursementFlag: 'Fee Collection Indicator',
          typeFacture: 'Invoice Type',
          accountholderAuthenticationValue : 'Account Holder Authentication Value',
          // Issuer
          emetteur: 'Issuer',
          issuerId: 'Distributor Reference',
          distributorRef: 'Distributor Name',
          memberId: 'Destination Member (ICA)',
          memberIdRec: 'Receiving Adherent Member',
          cardSchemeCode: 'Card Network',
          technicalProduct: 'Technical Product Reference',
          brand: 'Brand',
          pan: 'Cardholder Number',
          cardId: 'Card Identifier',
          expiryDate: 'Card Expiry Date',
          psn: 'Card PSN',
          referenceProduitCommercial: 'Commercial Product Reference',
          cardStatus: 'Card Status',
          refServiceBenef: 'Beneficiary Service Reference',
          libServiceBenef: 'Beneficiary Service Name',
          productExternalReference: 'Product Reference',
          beneficiaryServiceExternalReference: 'Beneficiary Service Reference',
          distributorData: 'DISTRIBUTOR DATA',
          beneficiary: 'BENEFICIARY',
          funder: 'FUNDER',
          // Acquirer
          acquereur: 'Acquirer',
          acquiringBIN: 'Acquirer BIN',
          idContratAffilie: 'Affiliate Id',
          idMarchand: 'Merchant Identifier',
          idStructure: 'Structure Identifier',
          domesticAcceptorTaxId: 'Merchant Tax Identifier / SIRET Number',
          accountCategory: 'Account Category',
          accountNumber: 'Account Number',
          nomMarchand: 'Merchant Name',
          rueMarchand: 'Merchant Address',
          villeMarchand: 'Merchant City',
          codepostalMarchand: 'Merchant Postal Code',
          regionMarchand: 'Merchant Region',
          countryCode: 'Merchant Country',
          idTerminal: 'Terminal Id',
          idAcceptation: 'Acceptance Id',
          codeMCC: 'MCC',
          acquirerReferenceNumber: 'Acquirer Reference Number (ARN)',
          retrievalReferenceNumber: 'RRN',
          traceNumber: 'Audit Number',
          idRemise: 'Settlement Identifier',
          paymentFacilitatorId: 'Payment Facilitator Identifier',
          subMerchantId: 'Final Merchant Identifier',
          // Operation Detail
          detailOperation: 'Operation Detail',
          transactionType: 'Transaction Type',
          canalAcceptationValue: 'Acceptance Channel',
          posEntryMode: 'POS Entry Mode',
          transactionOriginatorInstitutionIdCode: 'Originating Account Processing Code',
          transactionDestinationInstitutionIdCode: 'Destination Account Processing Code',
          dateTransaction: 'Transaction Date',
          transactionAmount: 'Transaction Amount',
          reconciliationAmount: 'Reconciliation Amount',
          exchangeRate: 'Reconciliation Currency Exchange Rate',
          cardHolderBillingAmount: 'Cardholder Billing Amount',
          cardholderConversionRate: 'Cardholder Billing Currency Exchange Rate',
          amountBeforeTopUp: 'Amount Before TopUp',
          complementAmount: 'Complement Amount',
          clearingPaymentComplement: 'Clearing Payment Complement',
          interchangeFees: 'Interchange Fees Amount',
          codeFraisInterchange: 'Interchange Fees Code',
          settlementDate: 'Settlement Date',
          authorizationOrigin: 'Authorization Number',
          traceId: 'Network Transaction Lifecycle Identifier',
          transactionLinkId : 'TLID',
          cardholderMerchantInitiatorTrInd: 'Transaction Initiator Indicator',
          originalIdOperation: 'Original Transaction',
          directSettlementMode: 'Direct Settlement Indicator',
          directSettlementInformation: 'Direct Settlement Information',
          insufficientBalanceFlag: 'Insufficient Balance Indicator',
          // Voucher Impact
          impactVoucher: 'Voucher Impact',
          externalReference: 'External Voucher Reference',
          accountImpact: 'Impact Amount on Voucher',
          // Security Data
          donneesSecuritaires: 'Security Data',
          ecommDef: 'E-Commerce',
          ecommData: 'E-Commerce Data',
          mdesData: 'MDES Data',
          ecomm: {
            donneesSecuritaires: '« Security » Data',
            transacIdAcceptor: 'Transaction Acceptor Identifier',
            cardholderAuthMethod: 'Cardholder Authentication Method',
            indicator: 'Elect Commerce Indicator',
            cryptogram: 'Cryptogram',
            cryptogramCalcMethod: 'Cryptogram Calculation Method',
            cryptogramProcessInfo: 'Cryptogram Processing Information',
            resultUseSecArch: 'Result',
            securityType: 'Securing Type',
            modifiedSecurityMode: 'Modified Securing Mode',
            additionalData: 'Additional Data',
            walletAdditionalData: 'Wallet Additional Data',
            walletName: 'Wallet Name',
            walletIdentifier: 'Wallet Identifier',
            securityProtocol: 'Security Protocol Type (MCI)',
            cardholderAuthentification: 'Cardholder Authentication Type (MCI)',
            ucafCollectionIndicator: 'UCAF Collection Indicator (MCI)',
            directoryServerTransactionId: 'Directory Server Transaction Id',
            programProtocol: 'Protocol Version'
          },
          xpayDef: 'MDES',
          xpay: {
            tokenRequestorId: 'Token Requestor ID',
            deviceType: 'Device Type',
            tokenWalletId: 'Wallet Identifier',
            tokenType: 'Token Type',
            tokenAccountNumber: 'Token Account Number',
            tokenAssuranceLevel: 'Token Assurance Level',
          },
          // Clearing File Data
          donneesFichierCompensation: '« Clearing File » Data',
          dateFichier: 'File Date',
          dateExtraction: 'Extraction Date',
          statutExtraction: 'Extraction Status',
          dateExtraction_: 'Extraction Date',
          fileId: 'Network File Identifier',
          numMessage: 'Message Number',
          // Export
          cardSchemeTransactionCycleId: 'Transaction Cycle Schema',
          messageTypeIdentifier: 'Message Type',
          functionCode: 'Processing Code',
          partialReversalFlag: 'Partial Reversal Indicator',
          partialReversalNumber: 'Partial Reversal Number',
          fromAccount: 'Account ',
          toAccount: '',
          externalOutputStatus: 'Output Status',
          externalOutputTimestamp: 'Output Timestamp',
          unmaskedPan: 'Unmasked PAN',
          cardholderAmount: 'Cardholder Amount',
          numAut: 'Authorization Number',
          authorizationNotFound: 'Authorization Not Found',
          purchaseNotFound: 'Purchase Not Found',
          unknownPAN: 'Unknown PAN',
          duplicateCtrlTop: 'Duplicate Control Indicator',
          latePresentationTop: 'Late Presentation Indicator',
          counterfeitCardTop: 'Counterfeit Card Indicator',
          offlineFlag: 'Offline Indicator',
          offlineAutReversalFlag: 'Offline Reversal Indicator',
          offlineAutReversalAmount: 'Offline Reversal Amount',
          voucherImpacts: 'Voucher Impacts',
          donneePrivee: 'Private Data',
          typePaiementOrigine: 'Origin Payment Type',
          idReseau: 'Network ID',
          authorizationReference: 'Authorization Reference',
          clearingReason: 'Clearing Reason',
          backofficeStatus: 'Dispute Status',
          backofficeFolderId: 'Dispute Folder ID',
          backofficeFolderName: 'Dispute Folder Name',
          idOperationAlreadyMatched: 'Already Matched Operation Identifier',
          itp: 'ITP',
          nlsa: 'NLSA',
          disputeReason: 'Dispute Reason',
          terminalType: 'Terminal Type',
          cardAcceptorCountryCode: 'Card Acceptor Country Code',
          authorizationIdMarchand: 'Merchant Authorization ID',
          authorizationIdAcceptation: 'Acceptance Authorization ID',
          actionDateAndTime: 'Action Date and Time',
          documentationIndicator: 'Documentation Indicator',
          feeCollectionControlNumber: 'Fee Collection Control Number',
          retrievalDocumentCode: 'Document Code',
          processingCode: 'Processing Code',
          reversalIndicator: 'Reversal Indicator',
          incomingFileReference: 'Unique Issuer Ref (CB2C)',
          settlementFileIdentifier: 'Settlement File Identifier'
        },
        funder: {
          label: 'Funder Label',
          funderContractRef: 'Funder Contract Reference',
          funderName: 'Funder Name',
          libContratFinanceur: 'Funder Contract Description',
          statutContratFinanceur: 'Funder Contract Status',
          funderProfilRef: 'Funder Profile Reference'
        }
      },
    },
    distributor: {
      reference: 'Reference',
      name: 'Name',
      issuerId: 'Issuer ID',
      creationDate: 'Creation Date',
      closingDate: 'Close Date',
      country: 'Country',
      dib1: 'DIB-1 : Distributor reference',
      dib2: 'DIB-2 : Distributor name',
      dib3: 'DIB-3 : Distributor identifier',
      dib4: 'DIB-4 : Distributor creation date',
      dib5: 'DIB-5 : Distributor close date',
      dib6: 'DIB-6 : Distributor identifier for the identification of the KME and the additional identifier of the issuer keys',
      dib7: 'DIB-7 : KCVC2 key mnemonic to be used for CVC control',
      dif2: 'DIF-2 : Extraction mode for the flow of card manufacturing orders (P1B1)',
      dif4: 'DIF-4 : Partial processing of an order in case of error (DF8-B1)',
      dif5: 'DIF-5 : Indicates whether the P1-B1 flow must be encrypted or not for the distributor',
      dif6: 'DIF-6 : Encryption key for a distributor used for industrial flow encryption P1-B1 card intended for ESB',
      dif7: 'DIF-7 : Industrial flow encryption key index card P1-B1 for ESB',
      dif8: 'DIF-8 : DF11-B file reduction criterion',
      dif9: 'DIF-9 : Maximum number of occurrences at the input of the PAN history consultation WS over 10 years',
      dif10: 'DIF-10 : Maximum number of WS consultations of 10-year PAN history per month',
      externalKMETag: 'External KME tag',
      internalKMETag: 'Internal KME tag',
      internalStorageTag: 'Internal storage tag',
      currencyCodeNum: 'Currency code',
      countryCodeNum: 'Country code',
      distributorUpdatedSuccess: 'Distributor {0} updated successfully',
    },
    param: {
      productViolationslist: 'Errors in the configuration file',
      productDifferenceslist: 'Differences between system configuration and configuration file',
      paramFile: 'Configuration file to check',
      violations: "Violation(s)"
    },
    product: {
      reference: 'Product Reference',
      name: 'Title',
      distributorRef: 'Distributor Reference',
      activationDate: 'Activation Date',
      deactivationDate: 'Deactivation Date',
      status: 'Status',
      expectedFormat: 'Expected format :',
      outOnly: 'Parameter not updatable, for information only',
      earliestUpdate: 'Update at the earliest opportunity',
      updateHours: 'Update Hours : \n - 11:00 PM \n - 08:00 AM',
      importFolder: 'Import Parameterization File',
      exportFolder: 'Export Products to a Parameterization File',
      close: 'Close',
      immediateUpdate: 'Earliest Update',
      updateDate: 'Update Date :',
      copiedFrom: 'Product copied based on product :',
      fromDistributor: ', from distributor :',
      createdProductsLastMonth: 'Number of product(s) created last month :',
      createdProductsThisMonth: 'Number of product(s) created this month :',
      editedProductsLastMonth: 'Number of product(s) edited last month :',
      editedProductsThisMonth: 'Number of product(s) edited this month :',
      creationSuccess: 'Product creation request successfully submitted (Product Reference : {productRef}), you will be redirected to the request section where you will be able to consult the newly created request.',
      infoPre28: 'This parameter is necessary for the proper functioning of the product. It is pre-filled when PRB-7 and PRB-11 are filled in, the `X` must be replaced by the key index, the question marks are replaced when selecting the distributor and finally you have to choose the BNT service between UMU_SECU and UMU_ISECU.',
      infoPrs323334: 'This parameter depends on the PRS-25 / 26 / 27 / 28 / 31 parameters and is automatically updated when they are filled in',
      productCopied: 'Product copied successfully into clipboard',
      productImported: 'Product imported successfully',
      updateSuccess: 'Product update request successfully submitted (Product Reference : {0}), you will be redirected to the request section where you will be able to consult the newly created update request.'
    },
    request: {
      distributorRef: 'Distributor Reference',
      productRef: 'Product Reference',
      requestStatus: 'Request Status',
      requestId: 'Request ID',
      requestDate: 'Effective Date',
      requestType: 'Request Type',
      requestUser: 'Request user',
      distributorDefaultAll: 'All Distributors (Default)',
      allStatus: 'All Status',
      PENDING: 'Pending',
      DONE: 'Done',
      IN_PROGRESS: 'In Progress',
      CANCELLED: 'Cancelled',
      FAILED: 'Failed',
      requestCancellation: 'Do you really want to cancel the request ?',
      cancelSuccess: 'Request successfully canceled',
      infoDetail: 'Details of request {0} ({1}) with consideration date of {2}',
      statusInfo: 'Request Status : {0}',
      modifiedParamsInProgress: 'List of parameters in progress of modification : (highlighted in the parameter blocks below)',
      modifiedParamsPending: 'List of parameters pending modification : (highlighted in the parameter blocks below)',
      modifiedParamsFailed: 'List of parameters that should have been modified, request failed, contact your administrator for more information : (highlighted in the parameter blocks below)',
      modifiedParamsCancelled: 'List of parameters that should have been modified, request cancelled : (highlighted in the parameter blocks below)',
      noModifiedParamsFound: 'No parameters modified found',
      valueBeforeUpdate: 'Value before update',
      valueAfterUpdate: 'Value after update',
      param: 'Parameter',
      undefined: 'Undefined',
      productDetail: 'Product Detail : {0}',
    },
    user: {
      statut: 'Status',
      token: 'Token',
      actions: 'Actions',
      selectedIdentification: 'Identifier',
      selectedEmail: 'Email',
      selectedEmailConfirmation: 'Email Confirmation',
      selectedDescription: 'Description',
      selectedRole: 'Role',
      selectedLanguage: 'Language',
      selectedDistributor: 'Distributor',
      selectedInternal: 'Internal',
      identificationFormat: 'Mandatory field. Alphanumeric field. Minimum 4 characters. Maximum 20 characters.',
      descriptionFormat: 'Alphanumeric field. Maximum 255 characters.',
      distributorFormat: 'The distributor must be known to the platform.',
      deleteUserMsg: 'The user {0} has been successfully deleted.',
      reinitPwd: 'The password of the user {0} has been successfully reset. A mail has been sent to the user.',
      lockUserMsg: 'The user {0} has been successfully locked.',
      unlockUserMsg: 'The user {0} has been successfully unlocked.',
      unlockUserResetPwdMsg: 'The user {0} has been successfully unlocked. Their password was locked, it has been reset, and an email has been sent.',
      resetOtpMsg: 'The OTP of the user {0} has been successfully reset.',
      updateSuccess: 'The user {0} has been successfully updated.',
      updateSuccessSelfRole: 'The user {0} has been successfully updated. The role of the connected user has been changed, you will be disconnected to apply the changes.',
      userCreatedSuccess: 'The user {0} has been successfully created.',
    },
    password: {
      login: 'Login ',
      oldPassword: 'Current Password',
      newPassword: 'New Password',
      newPasswordRepeat: 'New Password (verification)',
      passwordFormat: 'Mandatory field. Minimum 12 characters. Maximum 60 characters.',
      information: 'Information',
      inputPasswordRules1: 'Password must be between 12 and 60 characters, including at least one alphabetic, one numeric, one special, a lowercase and an uppercase character.',
      inputPasswordRules2: 'White characters and blank spaces are not allowed.',
      inputPasswordRules3: 'Reuse of any of the last 5 passwords is prohibited.',
      inputPasswordRules4: 'Password validity period is 90 days.',
      inputPasswordRules5: 'During the first login of a user with the password provided by the system, password change is mandatory.',
      inputPasswordRules6: 'Password renewal is mandatory and occurs during login after entering the old password.',
      infoChangePassword: 'Password change is done via the Keycloak system. By clicking on the button below, you will receive a password reset email with the steps to follow.',
      emailSentUpdatePwd: 'A password reset email has been sent to the address {0}.',
    },
    profile: {
      id: 'ID',
      description: 'Description',
      internal: 'Internal',
      lot: 'Lot',
      warning: 'Warning !',
      information: 'This page is critical for the operation of the application, do not create or edit roles withtout the permission of an administrator !',
      permissionsNb: 'Number of Permissions',
      actions: 'Actions',
      close: 'Close',
      permissions: 'Permissions',
      rolePermissions: 'ROLE PERMISSIONS',
      permissionName: 'Name',
      permissionDescription: 'Description',
      selectedRoleInternal: 'Internal Role',
      selectedRolePermissions: 'Permissions',
      selectedRoleLot: 'Batch associated with the role',
      selectedRoleDescription: 'Description',
      selectedRoleName: 'Name',
      profileCreatedSuccess: 'The role {0} has been successfully created.',
      profileUpdatedSuccess: 'The role {0} has been successfully updated.',
      profileDeletedSuccess: 'The role {0} has been successfully deleted.',
      permission: {
        distributors_all: 'Right to see data from all distributors',
        customerCare_view: 'Right to see customer care',
        distributors_read: 'Right to see distributors',
        distributors_write: 'Right to manage distributors',
        cards_read: 'Allows retrieving the list of cards',
        accounts_read: 'Allows retrieving the list of accounts',
        authorizations_read: 'Allows accessing authorization details',
        cards_write: 'Allows updating the list of cards',
        fullPan_view: '[TTNR] to view the full PAN',
        transaction_match: 'Right to match transactions manually',
        ttnr_access: 'Right to access unmatched transactions manual processing extranet',
        param_control: 'Right to control parameterization file',
        param_difference: 'Right to see difference between parameterization file and system configuration',
        role: 'Right to manage roles',
        customerCare: 'Right to manage customer care',
        beneficiaries_read: 'Allows retrieving the list of beneficiaries',
        commercialProduct_update: 'Right to modify any commercial product',
        parkAdmin_read: 'Right to see affiliates details',
        distributor_read: 'Right to see distributors',
        outstanding_emit: '[TTNR] Right to emit an outstanding',
        user: 'Right to manage users',
        users_read: 'Right to see users',
        users_write: 'Right to modify users',
        users_role: 'Right to manage roles',
        folder_close: '[TTNR] Right to close folder',
        commercialProduct_read: 'Right to see any commercial product',
        authorizations_detail: 'Allows accessing authorization details',
        internal: 'Right to see Internal data',
        authorizations_list: 'Right to list authorizations',
        distributor: 'Right to manage distributors',
        cards_unmaskPan: 'Allows having the option to display PANs',
        affiliates_read: 'Right to see affiliates',
        affiliates_write: 'Right to manage affiliates',
        technicalProduct: 'Right to manage technical products',
        parkAdmin: 'Right to manage affiliates',
        commercialProduct: 'Right to manage commercial products',
        clearings_read: 'Allows retrieving the list of clearings',
        orders_read: 'Allows retrieving the list of orders',
        product: 'Right to manage products',
        product_read: 'Right to see products',
        product_write: 'Right to create / modify products',
      }
    },
    modal: {
      ERROR_MODAL_LABEL: 'Error',
      SUCCESS_MODAL_LABEL: 'Success',
      CONFIRMATION_MODAL_LABEL: 'Confirmation',
      CONFIRMATION_MODAL_MSG: 'Are you sure you want to continue?',
      CONFIRMATION_MODAL_YES_BUTTON: 'Yes',
      CONFIRMATION_MODAL_NO_BUTTON: 'NO',
      ERROR_PRODUCT_CREATION: 'Error(s) creating product',
      ERROR_PRODUCT_UPDATE: 'Error(s) updating product',
      COPY_MODAL_LABEL: 'Copy Product',
      COPY_MODAL_MSG: 'Your browser does not allow automatic copying, please copy the product manually (Click on text area, CTRL + A then CTRL + C) :',
      PASTE_MODAL_LABEL: 'Product Import',
      PASTE_MODAL_MSG: 'Your browser does not allow automatic pasting, please paste the product manually in the area below (Copied previously on a product page with the Export button) :',
    }
  },

  title: {
    login: {
      welcome: 'Welcome to your space',
      main: 'Producer GUI'
    },
    home: {
      welcome: 'Welcome'
    },
    breadCrumb: {
      passwordchange: 'Change Password',
      distributorlist: 'List of Distributors',
      distributoredit: 'Edit Distributor',
      affiliatelist: 'Affiliates',
      affiliatedetail: 'Affiliate Contract Details',
      affiliateedit: 'Edit Affiliate Contract',
      authorizationlist: 'Authorizations',
      authorizationdetail: 'Authorization Details',
      cardlist: 'Cards',
      carddetail: 'Card Details',
      accountlist: 'Accounts',
      accountdetail: 'Account Details',
      beneficiaryservicelist: 'Beneficiary Services',
      beneficiaryservicedetail: 'Beneficiary Service Details',
      orderlist: 'Orders',
      orderdetail: 'Order Details',
      clearinglist: 'Clearings',
      clearingdetail: 'Clearing Details',
      productimport: 'Import Products',
      productexport: 'Export Products',
      productlist: 'Products',
      productdetail: 'Product Details',
      productedit: 'Edit Product',
      productcopy: 'Copy and Create Product',
      productcreate: 'Create Product',
      requestlist: 'List of Requests',
      requestdetails: 'Request Details',
      requestedit: 'Edit Request',
      paramcontrol: 'Control Parameterization File',
      profilecreate: 'Create Role',
      profilelist: 'List of Roles',
      profileedit: 'Edit Role',
      usercreate: 'Create User',
      userlist: 'List of Users'
    },
    distributors: 'Distributors ',
    distributorsList: 'List of Distributors',
    distributorsCreate: 'Create Distributor',
    distributorsEdit: 'Edit Distributor',
    products: 'Products ',
    product: {
      list: 'List of Products',
      detail: 'Product Details',
      edit: 'Edit Product',
      import: 'Import Products',
      export: 'Export Products',
      create: 'Create Product'
    },
    commercialProductsList: 'List of Commercial Products',
    commercialProductsCreate: 'Create Commercial Product',
    technicalProductsList: 'List of Technical Products',
    technicalProductsCreate: 'Create Technical Product',
    affiliates: 'Affiliate Contracts',
    affiliate: {
      list: 'Affiliate Contracts',
      details: 'Affiliate Contract Details',
      edit: 'Edit Affiliate Contract'
    },
    transactions: 'Unmatched Transactions',
    beneficiaries: 'Beneficiary Services',
    beneficiaryservice: {
      list: 'BENEFICIARY SERVICES',
      details: 'BENEFICIARY SERVICE DETAILS'
    },
    card: {
      list: 'Cards',
      details: 'Card Details'
    },
    account: {
      list: 'Accounts',
      details: 'Account Details'
    },
    authorization: {
      list: 'Authorizations',
      details: 'Authorization Details'
    },
    param: {
      control: 'Control Parameterization File'
    },
    clearing: {
      list: 'Clearings',
      details: 'Clearing Details'
    },
    user: {
      list: 'List of Users',
      creation: 'Create User',
      edition: 'Edit User',
      info: {
        unlockUser: 'Unlock User',
        deleteUser: 'Delete User',
        lockUser: 'Lock User',
        reinitUserPwd: 'Reset User Password',
        editUser: 'Edit User Information',
        resetOtp: 'Reset OTP',
      }
    },
    profile: {
      list: 'List of Roles',
      creation: 'Create Role',
      edition: 'Edit Role'
    },
    request: {
      list: 'List of Requests',
      details: 'Request Details'
    },
    accounts: 'Accounts',
    orders: 'Orders',
    admin: 'Administration',
    usersList: 'List of Users',
    usersCreate: 'Create User',
    passwordchange: 'Change Password',
    profilesPage: 'Manage Roles',
    batchPage: 'Batch Scheduling'
  },


  error: {
    TECHNICAL_ERROR: 'Technical Error',
    MANDATORY_CRITERIA: 'Mandatory Criteria.',
    UNAUTHORIZED_NB_RESULT: 'Number of results too high. Please refine your search.',
    EXCEEDED_DISPLAY_LIMIT: 'Number of results too high. Not all results were displayed',

    USER_ACCOUNT_EXPIRED: 'Access expired',
    USER_ACCOUNT_LOCKED_BY_TOO_MANY_WRONG_AUTHENTICATIONS: 'Access blocked. Too many incorrect login attempts.',
    USER_ACCOUNT_LOCKED_BY_ADMINISTRATOR: 'Access blocked by an administrator',
    USER_AUTHENTICATION_KO: 'Incorrect login and/or password',
    USER_UNKNOW_ERROR: 'Unknown error. Please try again in a few moments. If the problem persists, contact your administrator.',
    USER_AUTHENTICATION_MISSING: 'Please provide your login and password',
    IHM_DISTRIB_INCOMPLETE_DATA: 'Error retrieving distributor and/or product data',
    USER_DOESNT_EXISTS: 'User does not exist',
    USER_ALREADY_EXISTS: 'User already exists',
    USER_INCONSISTANT_DATABASE: '',
    USER_ROLE_DOESNT_EXISTS: 'Role does not exist',
    USER_ROLE_ALREADY_EXISTS: 'Role already exists',
    USER_ACCOUNT_CANT_BE_LOCKED: 'User account cannot be locked',
    USER_ACCOUNT_CANT_BE_UNLOCKED: 'User account cannot be unlocked',
    USER_PASSWORD_CHANGING_FAILED: 'Password change failed',
    USER_PASSWORD_CHANGING_FAILED_DUE_TO_HISTORY: 'Please comply with the conditions, reusing any of the last 5 passwords is prohibited',
    USER_PASSWORD_CHANGING_FAILED_DUE_TO_POLICY: 'Please comply with the password policy',
    USER_PASSWORD_CHANGING_FAILED_DUE_TO_PASSWORD_LENGTH: 'Password length does not meet the requirements',
    USER_PASSWORD_RESET_FAILED: 'Password reset failed',
    USER_INVALID_OPERATION: '',

    // AUTHORIZATION_MISSING_MANDATORY_CRITERIA: 'Un des 3 critères (Référence Distributeur / N° Porteur / Identifiant Carte) est obligatoire.',
    AUTHORIZATION_MISSING_MANDATORY_CRITERIA: 'One of the 2 criteria (Distributor Reference / Card Identifier) is mandatory.',
    AUTHORIZATION_MANDATORY_CRITERIA: 'Mandatory Criteria.',
    AUTHORIZATION_CARD_NUMBER_FORMAT: 'Number of 16 to 19 digits.',
    AUTHORIZATION_CARD_ID_FORMAT: 'Number up to 20 digits.',
    AUTHORIZATION_AUTHORIZATION_NUMBER_FORMAT: 'Number up to 6 digits.',
    AUTHORIZATION_MERCHANT_ID_FORMAT: 'Maximum 7 characters.',
    AUTHORIZATION_AMOUNT_FORMAT: 'Number up to 10 digits.',
    AUTHORIZATION_MAX_DATE_RANGE: 'The difference between the start date and end date should not exceed {range} day(s)',

    VALIDATION_MANDATORY_CRITERIA: 'Mandatory Criteria.',
    VALIDATION_FORMAT: 'Please comply with the required format.',
    VALIDATION_EMAIL_CONFIRMATION: 'Email and email confirmation fields do not match!',

    CARDS_CARD_ID_MIN_LENGTH: 'You must provide at least 5 characters for Card Identifier.',
    CARDS_CARD_ID_MAX_LENGTH: 'You can provide a maximum of 25 characters for Card Identifier.',
    CARDS_PAN_MIN_LENGTH: 'You must provide at least 11 characters for Card Number.',
    CARDS_PAN_MAX_LENGTH: 'You can provide a maximum of 19 characters for Card Number.',

    COMPENSATION_DATE_MANDATORY_CRITERIA: 'Transaction date or processing date is mandatory.',
    COMPENSATION_MISSING_MANDATORY_CRITERIA: 'One of the 4 criteria (Distributor Reference / Card Number / Card Identifier / Transaction Identifier) is mandatory.',
    COMPENSATION_DATE_TRANSACTION_RANGE: 'The difference between the start date and end date should not exceed 3 months',
    COMPENSATION_DATE_TRAITEMENT_RANGE: 'The difference between the start date and end date should not exceed 3 months',

    BAD_REQUEST: 'No operation found for these criteria. Please contact an administrator if the problem persists.',
    NOT_FOUND: 'No results found for these criteria.',
    NO_OPERATION_FOUND: 'No results found for these criteria.',
    SERVICE_EXCEPTION: 'Internal server error',
    UNAUTHORIZED: 'Unauthorized action. Contact your administrator for more details.',
    BAD_DATA_FORMAT: 'Bad data format',

    // ##
    // # WebService
    // # Ces valeurs viennent de l'enumeration CdjResponseCode de la couche WebService (net.atos.wlp.cdj.opc.contract)
    // # Elles sont préfixées par WEBS_ pour bien les distinguer et empecher les doublons.
    // # Basé sur la version du 14/02/13   ( <3 !)
    // ##
    WEBS_SUCCESS: 'Success !',
    WEBS_UNKNOWN_DISTRIBUTOR: 'Unknown distributor !',
    WEBS_MANDATORY_DATA_MISSING: 'Mandatory data missing !',
    WEBS_UNKNOWN_ERROR: 'Unknown error !',
    WEBS_UNKNOWN_PRODUCT: 'Unknown product !',
    WEBS_UNKNOWN_PROFILE: 'Unknown profile !',
    WEBS_UNKNOWN_FUNDER_CONTRACT: 'Unknown funder contract !',
    WEBS_VIOLATED_CONSTRAINT: 'Constraint violation !',
    WEBS_UNCONSISTENT_LIMIT: 'Inconsistent limit !',
    WEBS_UNCONSISTENT_PERIOD: 'Inconsistent period !',
    WEBS_INACTIVE_PRODUCT: 'Inactive product !',
    WEBS_FUNDER_CONTRACT_CLOSED: 'Funder contract closed !',
    WEBS_FUNDER_CONTRACT_ALREADY_EXISTS: 'Funder contract already exists !',
    WEBS_BENEFICIARY_SERVICE_ALREADY_EXISTS: 'Beneficiary service already exists !',
    WEBS_BENEFICIARY_SERVICE_CLOSED: 'Beneficiary service closed !',
    WEBS_UNCONSISTENT_FUNDER_CONTRACT: 'Inconsistent funder contract !',
    WEBS_FIRST_CARD_ALREADY_ISSUED: 'First card already issued !',
    WEBS_UNKNOWN_CARD: 'Unknown card !',
    WEBS_CARD_NOT_LINKED_TO_DISTRIBUTOR: 'Card not linked to a distributor !',
    WEBS_ACTIVATION_NOT_ALLOWED: 'Activation not allowed !',
    WEBS_ACTIVATION_LIMIT_DATE_EXCEEDED: 'Activation date exceeded !',
    WEBS_LOAD_OPERATION_NOT_AUTHORIZED: 'Loading operation not authorized !',
    WEBS_UNKNOWN_ORDER_GROUP: 'Unknown order group !',
    WEBS_UNCONSISTENT_BENEFICIARY_SERVICE: 'Inconsistent beneficiary service !',
    WEBS_INVALID_CARD_ORDER_STATUS: 'Invalid card order status !',
    WEBS_PAN_DECRYPTION_FAILED: 'PAN decryption failed !',
    WEBS_ACTIVATION_LIMIT_: 'Activation limit !',
    WEBS_CARD_NOT_CREATED: 'Card not created !',
    WEBS_EXPIRY_DATE_MANDATORY: 'Expiry date mandatory !',
    WEBS_CARD_STATUS_NOT_VALID_FOR_DEACTIVATION: 'Card status not valid for deactivation !',
    WEBS_INVALID_BLOCKING_REASON: 'Invalid blocking reason !',
    WEBS_CARD_LOSS_DATE_OUT_OF_BOUNDS: 'Card loss date out of bounds !',
    WEBS_UNCONSISTENT_VOUCHER_VALIDITY: 'Invalid voucher validity period !',
    WEBS_REFUSED_ACCOUNT_NOT_FOUND: 'Account not found !',
    WEBS_REFUSED_ACCOUNT_CLOSED: 'Account closed !',
    WEBS_REFUSED: 'Refused !',
    WEBS_PROFILE_ALREADY_EXISTS: 'Profile already exists !',
    WEBS_UNKNOWN_BENEFICIARY_SERVICE: 'Unknown beneficiary service !',
    WEBS_UNKNOWN_FUNDER_CONTRACT_PROFILE: 'Unknown funder contract profile !',
    WEBS_UNKNOWN_BENEFICIARY_PROFILE: 'Unknown beneficiary profile !',
    WEBS_RESUSED_AMOUNT_MISMATCHED: 'Refused amount mismatched !',
    WEBS_REFUSED_AMOUNT_MISMATCH_PERIOD: 'Refused amount mismatch period!',
    WEBS_REFUSED_CONTRACT_VIOLATION: 'Refused contract violation!',
    WEBS_REFUSED_VELOCITY_LIMIT_SLIDING_PERIOD: 'Refused velocity limit sliding period!',
    WEBS_REFUSED_MIN_AMOUNT_CHECKER: 'Refused min amount checker!',
    WEBS_REFUSED_MAX_AMOUNT_CHECKER: 'Refused max amount checker!',
    WEBS_REFUSED_BALANCE_LIMIT: 'Refused balance limit!',
    WEBS_UNCONSISTENT_VOUCHER_VALIDITY_PERIOD: 'Invalid voucher validity period!',
    WEBS_REFUSED_AMOUNT_MISMATCHED: 'Refused amount mismatched!',
    WEBS_UNKNOWN_ISSUER: 'Unknown issuer!',
    WEBS_NOT_DISTRIB_ISSUER: 'Distributor not issuer !',
    WEBS_BAD_ORDER_INTERNAL_STATUS: 'Incorrect order status !',
    WEBS_MAX_INPUT_LIST_EXCEEDED: 'Max input list exceeded !',
    WEBS_CURRENCY_CONTRACT_VIOLATION: 'Currency contract violation !',
    WEBS_CARD_ALREADY_ORDERABLE: 'Card already distributable !',
    WEBS_ISSUER_ALREADY_EXISTS: 'Issuer already exists !',
    WEBS_CARD_STATUS_INVALID: 'Invalid card status !',
    WEBS_ORDER_NOT_UNIQUE: 'Order already exists !',

    PARAM_CONTROL_NO_RESULT: 'No error in the parameterization file :',
    PARAM_CONTROL_NO_DIFFERENCE: 'No difference between the system parameterization and the parameterization file :',
    PARAM_CONTROL_ERROR: 'Error when checking the parameterization file :',
    PARAM_CONTROL_NO_FILE_SELECTED: 'No file selected',
    PRODUCT_MISSING_MANDATORY_CRITERIA: 'Distributor Reference is mandatory.',

    ITP_ERROR: 'Error occurred when contacting the ITP service',
    OPC_ERROR: 'Error occurred when contacting the OPC service',
    INVALID_TRANSACTION_STATUS: 'Invalid transaction status',
    INVALID_OPERATION_ID: 'Incorrect operation ID',
    INVALID_MAX_RESULTS: 'Incorrect maximum results',
    TRANSACTION_NOT_FOUND: 'No operation found for these criteria.',
    TOO_MANY_RESULTS: 'Number of results too high. Please refine your search.',

    AT_LEAST_ONE_ELEMENT_MUST_EXISTS: 'Data cannot be deleted because there must be at least one occurrence in the repository.',

    'Could not receive Message.': 'The request did not succeed. Please try again later',
    INVALID_FORM_PRODUCT: 'The product form is invalid. Please check the fields to make it valid.',
    NO_REQUESTS_FOUND: 'No requests found for these criteria.',
    CONVERSION_ERROR: 'Error during product creation, constraints below are not respected :',
    COM_001: 'Distributor not found',
    COM_002: 'Error during product creation, the constraints below are not respected:',
    COM_002_UPDATE: 'Error during product update, the constraints below are not respected:',
    COM_003: 'Technical error',
    COM_004: 'Product not found',
    COM_005: 'Error during product comparison',
    COM_006: 'Invalid or not found technical product',
    COM_007: 'Product not modified',
    COM_008: 'Parameters not allowed for modification',
    COM_009: 'Invalid product',
    COM_203: 'Product parameter change request not found (COM_203), please contact an administrator',
    INVALID_DATE_PRODUCT: 'Date must be at least 2 days more than today\'s date',
    PRODUCT_EMPTY: 'Error loading product, redirecting to product list',
    AUTHORIZATION_EMPTY: 'Error loading authorization, redirecting to authorization list',
    CLEARING_EMPTY: 'Error loading clearing, redirecting to clearing list',
    AFFILIATE_CONTRACT_EMPTY: 'Error loading affiliate contract, redirecting to affiliate contract list',
    BENEFICIARY_SERVICE_EMPTY: 'Error loading beneficiary service, redirecting to beneficiary service list',
    CARD_EMPTY: 'Error loading card, redirecting to card list',
    ACCOUNT_EMPTY: 'Error loading account, redirecting to account list',
    ORDER_EMPTY: 'Error loading order, redirecting to order list',
    INVALID_SCHEME: 'Invalid or unsupported card scheme (Check fields PRB-11 / PRB-15 / PRE-17 / PRE-28 / PRO-2)',
    INVALID_JSON_PRODUCT: 'Error during import, invalid JSON format for product',
    NO_UPDATED_PARAMS: 'No parameters have been found to update',
    REQUEST_EMPTY: 'Error loading request, redirecting to request list',
    IHM_SSO_SEND_MAIL_ERROR: 'Error sending email to perform required actions',
    IHM_SSO_NO_CREDENTIALS: 'Error resetting OTP, user has no credentials',
    IHM_SSO_NO_CONF_OTP: 'Error resetting OTP, user has not configured their OTP',
  }
}
